<template>
  <div>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="150">
        Cargando..
      </v-progress-circular>
    </v-overlay>

    <v-container fluid v-if="!isLoading">
      <!-- Sección de Clientes -->
      <v-row justify="center" id="nuestros-clientes">
        <v-col cols="12" xs12 sm8 lg12>
          <v-row justify="space-around">
            <v-col cols="12" align="center">
              <v-divider></v-divider>
              <br />
              <h1 class="text mb-8 white--text">NUESTROS CLIENTES</h1>
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col
          class="align-center"
          style="display: contents; zoom: 80%"
          cols="12"
          xs12
          sm8
          lg12
        >
          <div class="contenedor-empresas">
            <div
              v-for="cli in clientesFiltrados"
              :key="cli.id"
              v-if="cli.estado == 1"
            >
              <div @click="seleccionarCliente(cli)" style="cursor: pointer">
                <div class="contenedor-img">
                  <img :src="cli.logo2" class="imagenes-empresas" />
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Resto del template (Carousel, pasos, etc.) -->
      <br />
      <v-carousel cycle hide-delimiter-background height="500px">
        <v-carousel-item
          v-for="(item, i) in carouselItems2"
          :key="i"
          reverse-transition="fade-transition"
        >
          <v-img
            :src="item.src"
            class="white--text fill-height"
            height="auto"
            cover
          >
            <v-container fill-height>
              <v-row align="center" justify="center">
                <v-col cols="12" md="8" class="text-center">
                  <v-btn class="mt-4" color="secondary">
                    {{ item.buttonText }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-img>
        </v-carousel-item>
      </v-carousel>

      <!-- Resto del contenido -->
    </v-container>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import * as easings from "vuetify/es5/services/goto/easing-patterns";

export default {
  name: "Home",
  data() {
    return {
      filtro: "",
      init: false,
      // Propiedades propias del componente (carouselItems, etc.)
      carouselItems2: [
        {
          src: require("../assets/camion4.jpg"),
          title: "Sigue tu pedido de forma segura y confiable",
          buttonText: "Visítanos",
        },
        {
          src: require("../assets/camion5.jpg"),
          title: "Tú solo llegas más rápido, pero juntos llegamos más lejos.",
          buttonText: "Visítanos",
        },
        {
          src: require("../assets/camion6.jpg"),
          title: "Encuentra tu pedido de manera fácil",
          buttonText: "Visítanos",
        },
      ],
    };
  },
  created() {
    // Inicialización del tema, etc.
    this.init = true;
  },
  mounted() {
    this.listarCouriers();
  },
  computed: {
    isLoading() {
      return this.clientesFiltrados.length === 0;
    },
    ...mapGetters(["mapCouriers"]),
    ...mapState(["couriers"]),
    clientesFiltrados() {
      return this.couriers.filter((courier) =>
        courier.nombre.toLowerCase().includes(this.filtro.toLowerCase())
      );
    },
  },
  methods: {
    ...mapMutations(["setSelectedCourier"]),
    listarCouriers() {
      this.$store.dispatch("listarCouriers");
    },
    seleccionarCliente(cliente) {
      // Guarda el cliente seleccionado en el store
      this.setSelectedCourier(cliente);
      // Redirige a la ruta "empresas"
      this.$router.push({
        name: "empresas",
        query: { codigo: cliente.id, id: cliente.id_cliente },
      });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Serif&display=swap");

.contenedor-img {
  width: 7rem;
  height: 7rem;
  background-color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid rgb(0, 0, 0);
  border-radius: 10%;
}

.imagenes-empresas {
  width: 90%;
  cursor: pointer;
  border-radius: 5%;
}

.contenedor-empresas {
  background-image: url("https://images.unsplash.com/photo-1729459101552-3830ac71a95d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D");
  display: grid;
  width: 1600px; /* Aumentar el tamaño del contenedor */
  justify-content: center;
  min-height: 700px; /* Aumentar la altura mínima */
  max-height: 800px; /* Aumentar la altura máxima */
  gap: 3rem;
  grid-auto-rows: auto;
  opacity: 0.9;
  grid-template-columns: repeat(
    auto-fill,
    minmax(10rem, 1fr)
  ); /* Aumentar el tamaño mínimo de las columnas */
  border-top-left-radius: 25px;
  border-bottom-right-radius: 25px;
  overflow-x: auto;
  padding: 1.5rem;
  margin-bottom: 20px;
}

.contenedor-empresas div:hover {
  transform: scale(1.21);
}

::-webkit-scrollbar {
  width: 1.2vh;
  border-radius: 20px;
}

::-webkit-scrollbar-thumb {
  background-color: rgb(80, 80, 80);
  border-radius: 20px;
}

.texto-1 {
  width: 50%;
  color: white;
  font-size: 30px;
  text-transform: uppercase;
  font-family: "Noto Serif", serif;
}

.text {
  font-family: "Noto Serif", serif;
}

.contenedor-hero {
  width: 100%;
  height: auto;
}

.img-hero1 {
  width: 100%;
  height: 600px;
  background-image: url("../assets/camion1.jpg");
  background-repeat: no-repeat;
  background-position: 0% 80%;
  background-size: cover;
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
}

.card {
  width: 450px;
  height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
  color: black !important;
  border-radius: 28px;
  background: linear-gradient(45deg, #cacaca, #f0f0f0);
  box-shadow: 29px -29px 62px #b8b8b8, -29px 29px 62px #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card h1 {
  margin-bottom: 10px;
}

.f-card {
  display: flex;
  text-align: center;
  gap: 3rem;
  flex-wrap: nowrap;
}

.img-t {
  width: 350px;
  height: 150px;
  background-size: cover;
  background-position: center;
}

@media screen and (max-width: 968px) {
  .f-card {
    display: flex;
    flex-direction: column;
  }
  .card {
    width: 350px;
  }
}

a {
  margin: 0;
  padding: 0;
  line-height: 0;
}
</style>
